import { render, staticRenderFns } from "./AdditionalContent.vue?vue&type=template&id=76ae1fcc&"
import script from "./AdditionalContent.vue?vue&type=script&lang=js&"
export * from "./AdditionalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports